import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export interface AuditLogFilterData {
  dateRange: '1d' | '7d' | '30d' | 'all';
  actionType:
    | 'all'
    | 'login'
    | 'logout'
    | 'create'
    | 'read'
    | 'update'
    | 'delete'
    | 'permission_change'
    | 'financial'
    | 'moderation'
    | 'security'
    | 'export'
    | 'system';
  result: 'all' | 'success' | 'failure' | 'pending';
  source: 'all' | 'legacy' | 'subscriptions' | 'admin_ops' | 'security_events' | 'support_operations';
}

@Component({
  selector: 'app-audit-log-filter-modal',
  templateUrl: './audit-log-filter-modal.component.html',
  styleUrls: ['./audit-log-filter-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonRadioGroup,
    IonRadio,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
  ],
})
export class AuditLogFilterModalComponent implements OnInit {
  private modalCtrl: ModalController = inject(ModalController);
  @Input() filters?: Partial<AuditLogFilterData> | null;

  public dateRange: AuditLogFilterData['dateRange'] = '7d';
  public actionType: AuditLogFilterData['actionType'] = 'all';
  public result: AuditLogFilterData['result'] = 'all';
  public source: AuditLogFilterData['source'] = 'all';

  ngOnInit() {
    if (!this.filters) return;
    this.dateRange = this.filters.dateRange || '7d';
    this.actionType = this.filters.actionType || 'all';
    this.result = this.filters.result || 'all';
    this.source = this.filters.source || 'all';
  }

  applyFilters() {
    this.modalCtrl.dismiss({
      filters: {
        dateRange: this.dateRange,
        actionType: this.actionType,
        result: this.result,
        source: this.source,
      },
    });
  }

  clearFilters() {
    this.modalCtrl.dismiss({ clear: true });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
